module.exports = __webpack_public_path__ + "img/torso-gauged.d2372dd6.png";